const ROOM_PAGES = ['.page-template-rooms', '.single-room'];
const BOOKING_URL = 'https://www.secure-hotel-booking.com/d-edge/Best-Western-Premier-Le-Saint-Antoine/2YGA/fr-FR/DateSelection';

document.addEventListener('DOMContentLoaded', () => {
  const isRoomPage = ROOM_PAGES.some((selector) => document.body.matches(selector));
  if (!isRoomPage) {
    return;
  }

  const $btn = document.querySelector('.js-booking-btn');
  if (!$btn) {
    return;
  }

  const labelRooms = $btn.dataset.labelRooms;
  const newtab = $btn.dataset.newtab;

  $btn.href = BOOKING_URL;
  $btn.setAttribute('target', '_blank');
  $btn.setAttribute('rel', 'noopener noreferrer');
  $btn.setAttribute('aria-label', `${labelRooms} ${newtab}`);

  const $label = $btn.querySelector('.c-button__label');
  if ($label) {
    $label.textContent = labelRooms;
  }
});
